'use strict';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './body.routes';

export class BodyComponent {

  constructor($scope, $rootScope) {
    'ngInject';
    var $ctrl = this;

    // listening for state change and apply the appropriate class to body base on current state
    $scope.$on('$stateChangeSuccess', (event, toState) => {
      if(toState.hasOwnProperty('theme') && angular.isDefined(toState.theme)) {
        // converting . from some state names to - so it can be used as class name
        let currentStateName = toState.name.split('.').join('-');
        $ctrl.theme = `${toState.theme} ${currentStateName}`;
      }
    });

    $ctrl.screen = {
      width: window.screen.width,
      height: window.screen.height
    };
    // shim layer with setTimeout fallback
    window.requestAnimFrame = (function() {
      return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        };
    }($ctrl));
    let screenChecked = false;
    function checkScreenSize() {
      if(window.screen.width !== $ctrl.screen.width || window.screen.height !== $ctrl.screen.height) {
        $rootScope.$broadcast('ts:screenChanged');
        screenChecked = false;
      } else {
        if(!screenChecked) {
          $rootScope.$broadcast('ts:screenRestored');
          screenChecked = true;
        }
      }
    }

    // usage:
    // instead of setInterval(checkScreenSize, 50)
    // we use an animation frame;
    (function loop() {
      window.animFramRef = window.requestAnimFrame(loop);
      checkScreenSize();
    }($ctrl));

    $scope.$on('$destroy', () => {
      window.cancelAnimationFrame(window.animFramRef);
    });
  }
}

export default angular.module('fplTruescapeComApp.body', [uiRouter])
.config(routing)
.component('body', {
  controller: BodyComponent
})
.directive('bodyComponent', function() {
  return {
    scope: true,
    controller: BodyComponent,
    controllerAs: 'BodyController'
  };
})
.name;



// WEBPACK FOOTER //
// ./client/app/body/body.component.js